import { QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import { createQueryClient } from "@/api/query-client";
import { App } from "./App";

import "./styles/tokens.css";
import "./styles/baseline.css";
import "./styles/app.css";

// 配置（含"变更失败必须出声"的公共兜底）全部在 `api/query-client.ts`——
// 那里是唯一构造点，测试也用它，避免"测试跑的那份配置"与线上不是同一份。
const queryClient = createQueryClient();

const container = document.getElementById("root");
if (!container) throw new Error("缺少 #root 挂载点");

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
